// @flow
import type {
  ActivationBonus,
  ReferralBonuses,
  GodfatherBonus,
} from 'digicel-kaizen-library';

export type ReferralBonusesActionType =
  | {|
      type: 'FETCH_REFERRAL_BONUSES',
    |}
  | {|
      type: 'SET_REFERRAL_BONUSES',
      payload: {referralBonuses: ReferralBonuses},
    |};

export type GodfatherBonusActionType =
  | {|
      type: 'FETCH_GODFATHER_BONUS',
    |}
  | {|
      type: 'SET_GODFATHER_BONUS',
      payload: {godfatherBonus: GodfatherBonus},
    |};

export type ActivationBonusActionType =
  | {|
      type: 'FETCH_ACTIVATION_BONUS',
    |}
  | {|
      type: 'SET_ACTIVATION_BONUS',
      payload: {activationBonus: ActivationBonus},
    |};

export type FreeTrialActivationBonusActionType =
  | {|
      type: 'FETCH_FREE_TRIAL_ACTIVATION_BONUS',
    |}
  | {|
      type: 'SET_FREE_TRIAL_ACTIVATION_BONUS',
      payload: {freeTrial: Object},
    |};

export type BonusesActionType =
  | ReferralBonusesActionType
  | ActivationBonusActionType
  | GodfatherBonusActionType
  | FreeTrialActivationBonusActionType;

export const fetchReferralBonuses = (): ReferralBonusesActionType => ({
  type: 'FETCH_REFERRAL_BONUSES',
});

export const fetchGodfatherBonus = (): GodfatherBonusActionType => ({
  type: 'FETCH_GODFATHER_BONUS',
});

export const fetchActivationBonus = (): ActivationBonusActionType => ({
  type: 'FETCH_ACTIVATION_BONUS',
});

export const fetchFreeTrialActivationBonus =
  (): FreeTrialActivationBonusActionType => ({
    type: 'FETCH_FREE_TRIAL_ACTIVATION_BONUS',
  });

export const setReferralBonuses = (
  referralBonuses: ReferralBonuses,
): ReferralBonusesActionType => ({
  type: 'SET_REFERRAL_BONUSES',
  payload: {referralBonuses},
});

export const setActivationBonus = (
  activationBonus: ActivationBonus,
): ActivationBonusActionType => ({
  type: 'SET_ACTIVATION_BONUS',
  payload: {activationBonus},
});

export const setFreeTrialActivationBonus = (
  freeTrial: Object,
): FreeTrialActivationBonusActionType => ({
  type: 'SET_FREE_TRIAL_ACTIVATION_BONUS',
  payload: {freeTrial},
});

export const setGodfatherBonus = (
  godfatherBonus: GodfatherBonus,
): GodfatherBonusActionType => ({
  type: 'SET_GODFATHER_BONUS',
  payload: {godfatherBonus},
});
